import Base from 'app/views/base';

import tmpl from 'templates/selector';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .dropdown-menu a': 'changeSelection',
  },

  initialize() {
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    return {
      choices: this.model.choices,
      currentChoice: this.model.get('currentChoice'),
    };
  },

  changeSelection(e) {
    e.preventDefault();
    this.model.set('currentChoice', {
      option: $(e.currentTarget).data('option'),
      readable: $(e.currentTarget).text(),
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/selector_view.js